import { useQuery } from "@tanstack/react-query";

import { BrandEquityResponseV2 } from "@/@types/growthos-api/schema/openapi";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { QueryConfig } from "@/lib/react-query";
import { axiosApi } from "@/Utils";

export type DateGranularity = "week" | "month" | "quarter" | "half_year" | "year";

interface BrandEquityParams {
  startDate?: string | null;
  endDate?: string | null;
  brand: string;
  category: string;
  product: string;
  dateGranularity?: DateGranularity;
}

const getBrandEquity = (params: BrandEquityParams): Promise<BrandEquityResponseV2> => {
  return axiosApi.get("/api/brand-equity/v2", {
    baseURL: NEST_BACKEND_URL,
    params,
  });
};

export const useBrandEquity = ({
  startDate,
  endDate,
  brand,
  category,
  product,
  dateGranularity = "week",
  config,
}: BrandEquityParams & {
  config?: QueryConfig<typeof getBrandEquity>;
}) => {
  const params: BrandEquityParams = {
    brand,
    category,
    product,
    startDate,
    endDate,
    dateGranularity,
  };

  return useQuery({
    ...config,
    queryKey: ["brand-equity", brand, category, product, startDate, endDate, dateGranularity],
    queryFn: () => getBrandEquity(params),
  });
};
